var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDebtAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Analytics",
    xmlns: "http://www.w3.org/2000/svg",
    width: 234,
    height: 221,
    viewBox: "0 0 234 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19740",
    "data-name": "Path 19740",
    d: "M6.5,234.668h26a6.5,6.5,0,0,1,6.5,6.5v65a6.5,6.5,0,0,1-6.5,6.5H6.5a6.5,6.5,0,0,1-6.5-6.5v-65a6.5,6.5,0,0,1,6.5-6.5Zm0,0",
    transform: "translate(0 -91.668)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19741",
    "data-name": "Path 19741",
    d: "M113.166,149.332h26a6.5,6.5,0,0,1,6.5,6.5v117a6.5,6.5,0,0,1-6.5,6.5h-26a6.5,6.5,0,0,1-6.5-6.5v-117A6.5,6.5,0,0,1,113.166,149.332Zm0,0",
    transform: "translate(-41.667 -58.333)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19742",
    "data-name": "Path 19742",
    d: "M219.833,192h26a6.5,6.5,0,0,1,6.5,6.5v91a6.5,6.5,0,0,1-6.5,6.5h-26a6.5,6.5,0,0,1-6.5-6.5v-91A6.5,6.5,0,0,1,219.833,192Zm0,0",
    transform: "translate(-83.333 -75)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19743",
    "data-name": "Path 19743",
    d: "M326.5,128h26a6.5,6.5,0,0,1,6.5,6.5v130a6.5,6.5,0,0,1-6.5,6.5h-26a6.5,6.5,0,0,1-6.5-6.5v-130A6.5,6.5,0,0,1,326.5,128Zm0,0",
    transform: "translate(-125 -50)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19744",
    "data-name": "Path 19744",
    d: "M214.5,0A19.522,19.522,0,0,0,195,19.5a19.278,19.278,0,0,0,1.114,6.227L163.574,45.07a19.336,19.336,0,0,0-31.128,4.168l-28.7-14.215A19.527,19.527,0,0,0,104,32.5a19.5,19.5,0,1,0-37.512,7.434L29.259,67.717A19.275,19.275,0,0,0,19.5,65,19.7,19.7,0,1,0,37.693,77.645l37.6-28.062a19.087,19.087,0,0,0,22.578-2.961l32.637,16.165A19.482,19.482,0,0,0,169,58.5c0-.5-.11-.962-.145-1.447l35.391-21.04A19.306,19.306,0,0,0,214.5,39a19.5,19.5,0,1,0,0-39Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebtAnalytics);
export default __webpack_public_path__ + "static/media/Debt-Analytics.2aa6e12c4656778af27add168f48c3ed.svg";
export { ForwardRef as ReactComponent };